import { usePageView } from '@hooks/usePageView';
import { Outlet } from 'react-router';
import ModalWrapper from './ModalWrapper';

const RootLayoutWithoutNav = () => {
    usePageView();
    return (
        <ModalWrapper>
            <div className="flex flex-col w-full h-full min-h-[inherit] overflow-x-hidden justify-center items-center">
                <Outlet />
            </div>
        </ModalWrapper>
    );
};

export default RootLayoutWithoutNav;
